import React from 'react';
import {useParams} from 'react-router-dom';
import {getFile} from '../services/docs';

const GetFile = () => {
  const params  = useParams();
  const {fileName} = params;


  const getFileUlr = async (fileName: string) => {

    const res = await getFile(fileName);
    if (res.status === 200) {
      window.location.href = res.data.imageLink;
    } else {
      window.location.href = '/';
    }
  };

  React.useEffect(() => {
    getFileUlr(fileName);
  }, []);
  return null;
};

export default GetFile;
